import React from 'react';

const OurStory = () => {
    return (
        <>
            <div className="position-relative bg section-space-sm-top section-space-bottom">
                <div className="container">
                    <div className="row g-4 align-items-center">
                        {/* LEFT SIDE - TEXT */}
                        <div className="col-lg-6">
                            <div className="d-flex align-items-center flex-wrap gap-4 mb-4">
                                <div className="w-30 border-bottom border-2x border-neutral-100 welcome-dash" />
                                <h6 className="mb-0 clr-neutral-90 animate-text-from-right">Our Story</h6>
                            </div>

                            <h2 className="d4 clr-neutral-90 text-black mb-6 fw-extrabold animate-line-3d">
                                Blockchains struggle with
                                <span className="clr-grad-1"> real use.</span>
                            </h2>

                            <div className="pt-4 ps-4 pt-md-8 ps-md-16 border-start border-neutral-90 border-opacity-1">
                                <p className="mb-6 clr-neutral-80 animate-text-from-right">
                                    Zenochain  changes the game. We are building a Layer 1 chain from the ground up, with:
                                </p>

                                <ul className="list gap-6">
                                    {[
                                        "EVM compatibility for developers",
                                        "AI-powered automation & security for smarter dApps",
                                        "Proof-of-Alliance consensus for a trustable, community-led network",
                                        "Real-World Assets (Real Estate, SIPs, Mutual Funds) tokenized directly on-chain"
                                    ].map((text, index) => (
                                        <li key={index} className="welcome-list-1">
                                            <div className="d-flex gap-3">
                                                <span className="flex-shrink-0 d-grid place-content-center w-6 h-6 rounded-circle border border-primary-key border-opacity-3 bg-primary-key bg-opacity-2 clr-primary-key">
                                                    <i className="bi bi-check2 text-white" />
                                                </span>
                                                <span className="d-block clr-neutral-80">{text}</span>
                                            </div>
                                        </li>
                                    ))}
                                </ul>

                                <p className="mt-5 clr-neutral-80 animate-text-from-right">
                                    Our mission: to onboard millions into Web3 by offering real financial utilities, seamless developer tools, and a thriving ecosystem of dApps.
                                </p>
                            </div>
                        </div>

                        {/* RIGHT SIDE - IMAGE */}
                        <div className="col-lg-6">
                            <div className="text-center text-lg-end pe-xl-6">
                                <div className="d-inline-block position-relative image-wrapper">
                                    <img
                                        src="assets/img-1/blockchains-struggle-with-real-use.png"
                                        alt="img not found"
                                        className="img-fluid w-100 story-img "
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default OurStory;
